import * as React from 'react'
import { FaIcon, faClose } from '@/lib/fa'
import { useVehicleForm } from '../../context/VehicleFormContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const AddVehicleHeader = ({ close }: { close: () => void }) => {
  const { isEditState } = useVehicleForm()
  const { t } = useLocalize()

  return (
    <div className="tw-border-b tw-border-base-300">
      <div className="tw-flex tw-flex-col tw-gap-6 tw-py-4">
        <div className="tw-flex tw-items-center tw-justify-between tw-px-4">
          <p className="tw-text-xl tw-font-semibold tw-text-content-base">
            {isEditState ? t('vehicleModule.editing-vehicle') : t('vehicleModule.adding-vehicle')}
          </p>
          <FaIcon
            icon={faClose}
            className="tw-h-5 tw-w-5 tw-cursor-pointer"
            onClick={() => close()}
          />
        </div>
      </div>
    </div>
  )
}

export default AddVehicleHeader
